<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import website from "@/models/website";
import forminput from "@/router/views/formcomponet/forminput.vue";
import Drawer from "vue-simple-drawer";

export default {
  mixins: [apibtoast, apigeneric, website],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    forminput,
    Drawer,
  },
  data() {
    return {
      title: this.$t("website.Title"),
      items: [
        {
          text: this.$t("website.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("website.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilitrelemePenceresi: false,
      Filter: {
        Siteadi: "",
        Url: "",
      },
    };
  },
  validations: {
    Filter: {
      Siteadi: {},
      Url: {},
    },
  },

  methods: {
    Get() {
      this.ActionsGet({ Service: "website", Page: this.Page }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });

      let Filter = "";
      if (this.Filter.Siteadi != null && this.Filter.Siteadi != "")
        Filter = Filter + "&Siteadi=" + this.Filter.Siteadi;
      if (this.Filter.Url != null && this.Filter.Url != "")
        Filter = Filter + "&Url=" + this.Filter.Url;
      this.ActionsFilterGet({
        Service: "website",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-12">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.website
                      @click="(DataUpdate = websiteData), (AddEdit = 'Add')"
                    >
                      <i class="mdi mdi-plus me-1"></i
                      >{{ $t("website.Page.YeniKayitEkle") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary btn-rounded mb-2 me-2"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("website.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("website.Table.Siteadi") }}</th>
                      <th>{{ $t("website.Table.Tip") }}</th>
                      <th>{{ $t("website.Table.Url") }}</th>
                      <th>{{ $t("website.Table.Adminurl") }}</th>
                      <th>{{ $t("website.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <td>{{ Data.Siteadi }}</td>
                      <td>
                        <template
                          v-if="
                            Data.Tip == 'c0fc0f1a-d6d7-459a-b0d2-ee8da4dff55b'
                          "
                          >FAKÜLTE</template
                        >
                        <template
                          v-if="
                            Data.Tip == 'b150fe51-40ca-4a9d-a9c8-4a4605dcd865'
                          "
                          >ENSTİTÜ</template
                        >
                      </td>
                      <td>{{ Data.Url }}</td>
                      <td>{{ Data.Adminurl }}</td>
                      <td style="width: 100px; text-align: center">
                        <b-button-group>
                          <b-button
                            variant="success"
                            v-b-modal.website
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                            ><i class="far fa-edit"></i
                          ></b-button>
                          <b-button
                            variant="danger"
                            @click="Delete('website', Data.Id)"
                            ><i class="far fa-trash-alt"></i
                          ></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit
        :Id="DataUpdate"
        :AddEdit="AddEdit"
        @TableUpdate="Get()"
        v-show="DataUpdate"
      />
      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("website.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("website.Filtreleme.Content") }}

            <div class="mb-3 mt-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Siteadi',
                  Field: 'input',
                  FieldTitle: $t('website.Filtreleme.Siteadi'),
                }"
                :Value="Filter.Siteadi"
                :v="$v.Filter.Siteadi"
                @input="Filter.Siteadi = $event"
              />
            </div>
            <div class="mb-3 mt-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Url',
                  Field: 'input',
                  FieldTitle: $t('website.Filtreleme.Url'),
                }"
                :Value="Filter.Url"
                :v="$v.Filter.Url"
                @input="Filter.Url = $event"
              />
            </div>
            <b-button
              @click="Get(), (FilitrelemePenceresi = false)"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("website.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
